module.exports = __webpack_public_path__ + "static/media/express.6e22a763.png";